import React from 'react'
import { useReceiptVaultRules } from './useReceiptVaultRules'
import { ReceiptVaultRuleItem } from './receiptVaultRuleUtils'

type Props = {
  /** When true, show rules if org setting displayOnUploadPopup is enabled (uses prefetched cache). */
  show: boolean
  className?: string
  alwaysShow?: boolean
}

/**
 * Uses RTK cache of GetReceiptVaultUploadRules (prefetched after Receipt Vault list load).
 * Does not refetch on Upload click.
 */
const ReceiptVaultUploadRulesPanel = ({ show, className = '', alwaysShow = false }: Props) => {
  const { rulesObj, displayOnUploadPopup, isFetching, isError } = useReceiptVaultRules(show || alwaysShow)

  if (!show && !alwaysShow) return null

  if (isFetching) {
    return (
      <div className={`alert alert-primary py-3 mb-4 ${className}`}>
        <div className="text-center py-2">
          <span className="spinner-border spinner-border-sm text-primary" role="status" />
        </div>
      </div>
    )
  }

  if (!displayOnUploadPopup && !alwaysShow) return null

  return (
    <div className={`alert alert-primary py-3 mb-3 ss-rv-upload-rules-panel ${className}`}>
      <div className="fw-bold mb-2 ss-rv-upload-rules-title">
        {rulesObj.title || 'Receipt Vault Upload Rules'}
      </div>
      {isError ? (
        <div className="text-warning fs-7 mb-2">
          Could not load rules from settings. Showing default guidance.
        </div>
      ) : null}
      {rulesObj.intro ? <p className="mb-2 ss-rv-upload-rules-intro">{rulesObj.intro}</p> : null}
      <ol className="mb-0 ps-3 ss-rv-upload-rules-list">
        {(rulesObj.rules || []).map((rule, idx) => (
          <li key={idx} className="mb-1">
            <ReceiptVaultRuleItem rule={rule} />
          </li>
        ))}
      </ol>
    </div>
  )
}

export default ReceiptVaultUploadRulesPanel
